/* global thiss */
var Theme = Theme || {};

Theme.ShibbolethSignin = (function ($) {

    return {
        init: _init,
        redirectToShibboleth: _sendShibbolethData,
        initSeamlessAccess: _initSeamlessAccess
    };

    function _init() {
        handleFederationChange();
        repopulateInstitutionsOnPageShow();
        handleShibbolethFormSubmit();
        checkOpenAthens();
    }

    function handleFederationChange() {
        $('#FederationDropdown').on('change', function (e) {
            _fetchShibbolethInstitutions($(e.target));
        });
    }

    function repopulateInstitutionsOnPageShow() {
        let $federationDropdown = $('#FederationDropdown');
        $(window).on('pageshow', function () {
            if ($federationDropdown.val()) {
                _fetchShibbolethInstitutions($federationDropdown);
            }
        });
    }

    function _fetchShibbolethInstitutions($target) {
        if (!$target.length) {
            return;
        }

        let federationID = $target.val();
        let ajaxUrl = '/UserDashboard/GetInstitutionsForFederation';
        let ajaxData = { FederationID: federationID };

        if (federationID) {
            SCM.Ajax.post(ajaxUrl, ajaxData)
                .expectJson()
                .then(_updateInstitutionDropdown)
                .catch(console.error);
        }
    }

    function _updateInstitutionDropdown(institutionList) {
        let $institutionDropdown = $('#InstitutionDropdown');
        let defaultInstitution = institutionList.find(institution => institution.IsDefault);

        _clearInstitutionOptions($institutionDropdown);

        if (defaultInstitution) {
            _selectDefaultInstitution($institutionDropdown, defaultInstitution);
        } else {
            _populateInstitutions($institutionDropdown, institutionList);
        }
    }

    function _clearInstitutionOptions($institutionDropdown) {
        $institutionDropdown.find('option:gt(0)').remove();
    }

    function _selectDefaultInstitution($institutionDropdown, defaultInstitution) {
        let $institutionWrapper = $institutionDropdown.closest('.input_wrap');
        $institutionWrapper.addClass('hide');
        $institutionDropdown.append(`<option value="${defaultInstitution.ShibbolethID}">${defaultInstitution.InstitutionName}</option>`);
        $institutionDropdown.val(defaultInstitution.ShibbolethID);
    }

    function _populateInstitutions($institutionDropdown, institutionList) {
        let $institutionWrapper = $institutionDropdown.closest('.input_wrap');
        $institutionWrapper.removeClass('hide');
        institutionList.forEach(institution => {
            $institutionDropdown.append(`<option value="${institution.ShibbolethID}">${institution.InstitutionName}</option>`);
        });
    }

    function handleShibbolethFormSubmit() {
        $('#shibbolethSelectBtn').on('click', _testShibbolethId);
    }

    function _testShibbolethId() {
        let shibbolethID = $('#InstitutionDropdown').val();

        if (shibbolethID) {
            _sendShibbolethData(shibbolethID);
        }
        else {
            $('#shibboleth-error').html('Please select an institution');
        }
    }

    function _sendShibbolethData(shibbolethID) {
        let ajaxUrl = '/UserDashboard/RedirectToShibboleth';
        let ajaxData = { ShibbolethID: shibbolethID };

        SCM.Ajax.post(ajaxUrl, ajaxData)
            .expectJson()
            .then(_setReturnUrlCookie)
            .then(_navigateToShibboleth)
            .catch(console.error);
    }

    function _setReturnUrlCookie(ajaxResponse) {       
        let urlParams = new URLSearchParams(document.location.search);
        let returnUrl = urlParams.get('returnUrl');

        if (returnUrl) {
            returnUrl = _ensureUrlIsEncoded(returnUrl);
            document.cookie = `returnUrl=${returnUrl}`;
        }

        return ajaxResponse;
    }

    function _navigateToShibboleth(ajaxResponse) {
        window.location.assign(_withLoginReturnTarget(ajaxResponse));
    }

    function _initSeamlessAccess() {
        if (!$('#seamlessAccessLogin').length || typeof thiss === 'undefined' || !thiss.DiscoveryComponent) {
            return;
        }

        thiss.DiscoveryComponent.render({
            loginInitiatorURL: _withLoginReturnTarget('https://' + window.location.host + '/Shibboleth.sso/Login')
        }, '#seamlessAccessLogin');
    }

    function _withLoginReturnTarget(loginUrl) {
        const target = _getLoginReturnTarget();
        const separator = loginUrl.indexOf('?') >= 0 ? '&' : '?';

        if (target === null) {
            return loginUrl;
        }

        return loginUrl + separator + 'target=' + encodeURIComponent(target);
    }

    function _getLoginReturnTarget() {
        const candidateUrl = _getSameHostReturnUrl() || new URL(window.location.href);

        if (SCM.JSUtility.isBeforeSignInOnlyUrl(candidateUrl.pathname)) {
            return null;
        }

        return window.location.origin + candidateUrl.pathname + candidateUrl.search + candidateUrl.hash;
    }

    function _getSameHostReturnUrl() {
        const returnUrl = new URLSearchParams(document.location.search).get('returnUrl');
        let parsedReturnUrl;

        if (!returnUrl) {
            return null;
        }

        try {
            parsedReturnUrl = new URL(returnUrl, window.location.origin);
        } catch (e) {
            return null;
        }

        return parsedReturnUrl.host === window.location.host ? parsedReturnUrl : null;
    }

    function _ensureUrlIsEncoded(url) {
        let decodedUrl = decodeURIComponent(url);
        if (url === decodedUrl) {
            url = encodeURIComponent(url);
        }
        return url;
    }

    function checkOpenAthens() {
        if (window.location.search.indexOf('openathens=') >= 0) {
            $('#FederationDropdown option:contains("OpenAthens Federation")').attr('selected', 'selected').change();
        }
    }

})(jQuery);